// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2vtQ7","loaderOuter":"PageOverlayLoader_loaderOuter__2GWMI"};